<template>
  <div class="ls-select-tab-box">
    <div class="tree-box">
      <TreeSelect @select="selectNode"></TreeSelect>
    </div>
    <div class="table-box">
      <div class="ls-select-search-box">
        <div class="search-item">
          <el-input
            v-model="search.username"
            placeholder="请输入账号"
            clearable
            @keyup.enter="searchEvt"
          />
        </div>
        <div class="search-item">
          <el-input
            v-model="search.realName"
            placeholder="请输入姓名"
            clearable
            @keyup.enter="searchEvt"
          />
        </div>
        <el-button type="primary" @click="searchEvt">搜索</el-button>
      </div>
      <div class="table-main">
        <div class="table-content">
          <el-table
            ref="orgUserTable"
            :data="tableData"
            :row-key="nodeKey"
            size="default"
            style="width: 100%"
            height="100%"
            class="ls-table"
            border
            stripe
            show-overflow-tooltip
            empty-text="暂无数据"
            :header-cell-class-name="cellClass"
            @select="rowSelect"
          >
            <el-table-column
              :show-overflow-tooltip="false"
              type="selection"
              width="50"
              align="center"
              :selectable="selectable"
              fixed
            />
            <el-table-column label="账号" prop="username" width="100"></el-table-column>
            <el-table-column label="姓名" prop="realName" width="100"></el-table-column>
            <el-table-column label="信息">
              <template #default="{ row }">
                <div class="ls-table-info-box">
                  <span>手机号 : {{ row.mobile ? row.mobile : "--" }}</span>
                  <span>座机号 : {{ row.telephone ? row.telephone : "--" }}</span>
                  <span>邮箱 : {{ row.email ? row.email : "--" }}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="footer">
          <span>15条/页</span>
          <el-pagination
            background
            layout="prev, pager, next"
            :pager-count="15"
            :current-page="currentPage"
            :total="total"
            class="footer-page"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TreeSelect from "../TreeSelect/index.vue";
import request from "../../../api/request";
export default {
  name: 'UserSelectOrg',
  components: {
    TreeSelect
  },
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    selections: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      search: {
        includeOrgIds: [],
        username: "",
        realName: ""
      },
      tableData: [],
      currentPage: 1,
      total: 0,
      nodeKey: "userId"
    }
  },
  watch: {
    selections: {
      deep: true,
      handler() {
        this.setTableSelection(this.selections, this.nodeKey);
      }
    },
  },
  methods: {
    /*获取可选人员列表*/
    async getUserTable() {
      try {
        // const { success, message, data } = await lsfetch.post(
        //   "/api-type/base/current/operate/member-page-of-org",
        //   {
        //     username: lstool.trim(this.search.username),
        //     realName: lstool.trim(this.search.realName),
        //     includeOrgIds: this.search.includeOrgIds,
        //     current: this.currentPage,
        //     pageSize: 15
        //   }
        // );
        const { success, message, data } = await request({
          url: "/api-type/base/current/operate/member-page-of-org",
          method: "post",
          data: {
            username: this.search.username,
            realName: this.search.realName,
            includeOrgIds: this.search.includeOrgIds,
            current: this.currentPage,
            pageSize: 15
          }
        });
        // const { success, message, data } = { success:false, message:"111", data:[]}
        if (!success) {
          return this.$message.error("获取机构成员失败:" + message);
        }
        let temp = [],
          totalNum = 0;
        if (data && data.records && data.records.length) {
          temp = data.records;
          totalNum = data.total;
        }
        this.tableData = temp;
        this.total = totalNum;
        this.$emit("finish");
      } catch (e) {
        this.$message.error("获取机构成员失败:" + e.message || e);
      }
    },
    /*点击树checkbox*/
    selectNode(data) {
      if (data && data.length) {
        let temp = [];
        if (data && data.length) {
          data.map((item) => {
            temp.push(item.id);
          });
        }
        this.search.includeOrgIds = temp;
        this.searchEvt();
      } else {
        this.search.includeOrgIds = [];
        this.tableData = [];
      }
    },

    /*单选时将表头的checkbox隐藏*/
    cellClass(row) {
      if (row.columnIndex === 0 && !this.multiple) {
        return "disabledCheck";
      }
    },

    /*点击选择框*/
    rowSelect(selection) {
      //单选
      if (!this.multiple) {
        if (selection.length > 1) {
          const del_row = selection.shift();
          this.$refs.orgUserTable.toggleRowSelection(del_row, false); //用于多选表格，切换某一行的选中状态，如果使用了第二个参数，则是设置这一行选中与否（selected 为 true 则选中）
        }
        this.$emit("single");
      }
    },

    /*搜索*/
    searchEvt() {
      this.getUserTable();
    },

    /*当前页改变*/
    handleCurrentChange(value) {
      this.currentPage = value;
      this.getUserTable();
    },

    /*返回被选中的行*/
    getSelections() {
      return this.$refs.orgUserTable.selection;
    },

    /*重新设置表格选中状态*/
    setTableSelection(selections, key) {
      this.tableData.map((row) => {
        const result = selections.find((item) => row[key] == item[key]);
        if (result) {
          this.$refs.orgUserTable.toggleRowSelection(row, true);
        }
      });
    },

    /*设置表格选中/取消选中*/
    toggleRowSelection(selections, key, flag) {
      selections.map((item) => {
        const result = this.tableData.find((row) => row[key] == item);
        if (result) {
          this.$refs.orgUserTable.toggleRowSelection(result, flag);
        }
      });
    },

    /*设置表格行能否选择*/
    selectable(row) {
      const data = this.selections.find((item) => item[this.nodeKey] === row[this.nodeKey]);
      return !data;
    },

    /*清空表格选中*/
    clearTableSelection() {
      this.tableData.map((row) => {
        this.$refs.orgUserTable.toggleRowSelection(row, false);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.ls-select-tab-box {
  width: 100%;
  height: 100%;

  &:after {
    display: block;
    width: 0;
    height: 0;
    content: "";
    overflow: hidden;
    clear: both;
  }

  > .tree-box {
    float: left;
    width: 300px;
    height: 100%;
  }

  > .table-box {
    float: left;
    width: calc(100% - 300px);
    height: 100%;

    > .ls-select-search-box {
      border-left: 1px solid var(--ls-ui-user-select-border-color);
      border-right: 1px solid var(--ls-ui-user-select-border-color);
    }

    > .table-main {
      width: 100%;
      height: calc(100% - 62px);

      > .table-content {
        width: 100%;
        height: calc(100% - 52px);

        .ls-table {
          ::v-deep(.disabledCheck) {
            .cell {
              .el-checkbox {
                display: none;
              }
            }
          }
        }
      }

      > .footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: right;
        padding: 10px;
        border-left: 1px solid var(--ls-ui-user-select-border-color);
        border-right: 1px solid var(--ls-ui-user-select-border-color);
      }
    }
  }
}

.ls-table-info-box {
  overflow: hidden;

  > span {
    margin-left: 10px;

    &:first-child {
      margin-left: 0;
    }
  }
}
</style>
